import FormControl from '@mui/joy/FormControl'
import FormLabel from '@mui/joy/FormLabel'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'

export const TimeFieldV2 = ({ label, value, disabled, onChange }) => {
    const ignoreKeyDown = (e) => {
        e.preventDefault()
    }

    return (
        <FormControl>
            <FormLabel>{label}</FormLabel>
            <TimePicker
                disabled={disabled}
                value={value}
                timeSteps={{ minutes: 60 }}
                slotProps={{
                    textField: { onKeyDown: ignoreKeyDown, size: 'small' },
                }}
                onChange={onChange}
            />
        </FormControl>
    )
}
